let env = {};

env.baseURL = 'https://api.pesquisa.humanflow.com.br/api/v1/';
env.normalURL = 'https://api.pesquisa.humanflow.com.br/';
env.frontUrl = 'https://app.pesquisa.humanflow.com.br/';

export default env



// WEBPACK FOOTER //
// ./src/config/env.js